module.exports = __webpack_public_path__ + "static/media/swords.a7a906fa.svg";